import React, { useState, useRef } from 'react';
import { apiService } from '../services/api'; 
import './style/ImportOrganisationWidget.css'; 

const ImportOrganisationWidget = ({ onClose, onSave }) => {
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type === "text/csv") {
      setFile(selectedFile);
      setError('');
    } else {
      setFile(null);
      setError('Please select a valid .csv file');
    }
  };

  const downloadTemplate = () => {
    // Includes custom_id and examples using the specific allowed types
    const headers = "custom_id,name,type,contact_email,location,description";
    const rows = [
      "1001,Example Corp,Head Office Account,admin@example.com,New York,Main HQ",
      "1002,National Supply Co,National Account,supply@example.com,Chicago,National distributor",
      "1003,Local Board,Board,board@example.com,London,Regional board",
      "1004,Tech Parts Ltd,Supplier,parts@example.com,Berlin,Tech supplier",
      "1005,City Power,Utilities,power@example.com,Paris,Electric utility",
      "1006,Global Trade,Wholesaler,trade@example.com,Tokyo,Bulk goods",
      "1007,John Doe Store,Customer,john@example.com,Sydney,Retail customer"
    ];
    
    const csvContent = [headers, ...rows].join("\n");
    
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'organisation_import_template.csv';
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const handleUpload = async () => {
    if (!file) {
      setError('Please select a file first.');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const formData = new FormData();
      formData.append('file', file);

      await apiService.importOrganisations(formData);
      
      alert('Import successful!');
      onSave(); 
    } catch (err) {
      console.error(err);
      setError('Failed to import. Please check the file format and try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="import-widget-overlay">
      <div className="import-widget-container">
        
        <div className="widget-header">
          <h3>Import Organisations</h3>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        <div className="widget-content">
          
          {/* Step 1: Template */}
          <div className="template-download-section">
            <p className="import-step-text">
              <strong>Step 1:</strong> Download the template to ensure your data is formatted correctly.
            </p>
            <div className="template-info" style={{ fontSize: '0.85rem', color: '#666', marginBottom: '10px' }}>
              <em>Valid Types: Head Office Account, National Account, Board, Supplier, Utilities, Wholesaler, Customer</em>
            </div>
            <button className="btn-download-template" onClick={downloadTemplate}>
              ⬇ Download CSV Template
            </button>
          </div>

          {/* Step 2: Upload */}
          <div className="import-step">
            <p className="import-step-text">
              <strong>Step 2:</strong> Upload your CSV file.
            </p>
            <input 
              type="file" 
              accept=".csv"
              ref={fileInputRef}
              onChange={handleFileChange}
              className="file-input-field"
            />
          </div>

          {/* Error Message */}
          {error && (
            <div className="import-error-msg">
              {error}
            </div>
          )}

          {/* Actions */}
          <div className="import-actions">
            <button 
              className="action-btn btn-cancel" 
              onClick={onClose} 
              disabled={isLoading}
            >
              Cancel
            </button>
            <button 
              className="action-btn primary" 
              onClick={handleUpload}
              disabled={!file || isLoading}
            >
              {isLoading ? 'Importing...' : 'Upload & Import'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportOrganisationWidget;
